import { SvgIcon } from '@material-ui/core'

export default function UnheartIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M16.2208 5.59854C16.336 5.48336 16.2721 5.2884 16.1099 5.27343C15.9418 5.25793 15.7717 5.25 15.6 5.25C14.1665 5.25 12.9052 5.92214 12 6.79183C11.0948 5.92214 9.83347 5.25 8.4 5.25C5.61914 5.25 3.25 7.3293 3.25 10.0298C3.25 11.8927 4.12235 13.4612 5.27849 14.7604C5.49211 15.0005 5.71722 15.2334 5.95078 15.4593C6.06686 15.5716 6.25123 15.5681 6.36544 15.4539L16.2208 5.59854Z"
                fill="currentColor"
            />
            <path
                d="M4.50295 19.4364L4.46967 19.4697C4.17678 19.7626 4.17678 20.2374 4.46967 20.5303C4.76256 20.8232 5.23744 20.8232 5.53033 20.5303L8.52035 17.5403C8.77001 17.7167 9.01783 17.8871 9.26097 18.0516L11.5796 19.6211C11.8335 19.793 12.1665 19.793 12.4204 19.6211L14.739 18.0516C16.0829 17.142 17.5693 16.0552 18.7215 14.7604C19.8777 13.4612 20.75 11.8927 20.75 10.0298C20.75 8.73357 20.2042 7.58046 19.3289 6.73172L21.5303 4.53033C21.8232 4.23744 21.8232 3.76256 21.5303 3.46967C21.2464 3.18574 20.7914 3.17705 20.497 3.44361L4.53033 19.4103C4.52137 19.4193 4.51224 19.428 4.50295 19.4364Z"
                fill="currentColor"
            />
        </SvgIcon>
    )
}
